import { useContext, useEffect } from 'react'

import { Box, Image, Text } from '@fairfashion/design-system'

import { HeaderInformationItem } from '../../../../components/HeaderInformationItem/header-information-item.comp'
import { ProductDetailsContext } from '../../product-details.context'
import * as ProductDetailsStyles from '../../product-details.styles'

import * as Styles from './product-header.styles'

export const ProductHeader = () => {
  const { productDetails, productItems, actions } = useContext(
    ProductDetailsContext,
  )

  useEffect(() => {
    actions.getDetails()
  }, [])

  return (
    <ProductDetailsStyles.Card gap={3} flexWrap="wrap" alignItems="stretch">
      <Box width="230px" alignItems="center">
        <Box borderRadius="8px" overflow="hidden">
          <Image
            width="230px"
            height="230px"
            alt="Product Image"
            src={productDetails?.images?.[0] || '/assets/default-image.png'}
          />
        </Box>
      </Box>
      <Box flex={1} direction="column" gap={2}>
        <Box gap={3} alignItems="center">
          <Box gap={1} alignItems="center">
            <Text color="grey_3" fontWeight={400} size="small">
              Produto:
            </Text>
            <Text fontWeight={500} size="small">
              {productDetails?.description}
            </Text>
          </Box>
          {productDetails?.brandName && (
            <Box gap={1} alignItems="center">
              <Text color="grey_3" fontWeight={400} size="small">
                Marca:
              </Text>
              <Text fontWeight={500} size="small">
                {productDetails?.brandName}
              </Text>
            </Box>
          )}
        </Box>
        <Styles.InformationContainer
          width="100%"
          justifyContent="space-between"
          gap={2}
        >
          <HeaderInformationItem
            label="SKU ou Identificador do Produto"
            value={productDetails?.code}
            icon="barcode_box"
            iconColor="purple"
          />
          <HeaderInformationItem
            label="Quantidade produzida"
            value={productDetails?.quantity?.toString()}
            icon="clipboard"
            iconColor="primary"
          />
          <HeaderInformationItem
            label="Fábricas"
            value={productDetails?.providersCount?.toString()}
            icon="building3"
            iconColor="gray_blue"
          />
          <HeaderInformationItem
            label="Notas Fiscais"
            value={productDetails?.invoicesCount?.toString()}
            icon="receipt"
            iconColor="light_orange"
          />
          <HeaderInformationItem
            label="Processos produtivos"
            value={productDetails?.orderProductionsCount?.toString()}
            icon="swap2"
            iconColor="secondary"
          />
          {!!productItems?.count && (
            <HeaderInformationItem
              label="QRCode"
              value={
                productDetails?.qrcodeAccess
                  ? `${productDetails?.qrcodeAccessCount} acessos`
                  : 'Inativo'
              }
              icon="qr_code"
              iconColor="light_blue"
              url={`/qrcode/${productDetails?.code}`}
            />
          )}
        </Styles.InformationContainer>
      </Box>
    </ProductDetailsStyles.Card>
  )
}
